import type { ConnectorClassifyContent } from "../content-types";
import { Explanation, Prompt } from "./shared";
import { PickButtons } from "./drill-helpers";
import type { QuestionRendererProps } from "./types";

/** Classify each connector's semantic relation (mirrors iOS
 *  ConnectorClassifyView: pick the correct class per item). */
export function ConnectorClassifyRenderer({ content, answer, setAnswer, revealed }: QuestionRendererProps) {
  const c = content as unknown as ConnectorClassifyContent;
  const items = c.items ?? [];
  const map = (answer as Record<string, string>) ?? {};
  return (
    <div>
      <Prompt>{c.prompt}</Prompt>
      <div className="mt-4 space-y-3">
        {items.map((it) => (
          <div key={it.id} className="rounded-xl bg-slate-50 p-3">
            <div className="mb-2 text-sm text-ink">{it.sentence}</div>
            <PickButtons
              options={c.tray_classes ?? []}
              chosen={map[it.id]}
              correct={it.correct_class}
              revealed={revealed}
              onPick={(v) => setAnswer({ ...map, [it.id]: v })}
            />
            {revealed && map[it.id] && map[it.id] !== it.correct_class && it.near_miss_rationale && (
              <p className="mt-1.5 text-xs text-ink-faint">{it.near_miss_rationale}</p>
            )}
          </div>
        ))}
      </div>
      {revealed && <Explanation text={c.explanation} />}
    </div>
  );
}
